package com.yendo.mx.repository

import com.yendo.mx.models.AppGlobalConfig
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore

object ConfigGlobalRepository {
    private val db by lazy { Firebase.firestore }

    // 🚀 CACHÉ EN MEMORIA PARA ACCESO RÁPIDO DESDE CUALQUIER PANTALLA
    var configCargada: AppGlobalConfig? = null

    // 🚀 CONTROL DE ACTUALIZACIÓN SUAVE (Persistente durante la sesión)
    var mostrarSoftUpdateEnHome: Boolean = false
    var urlSoftUpdate: String = ""

    // 🚀 LECTURA DIRECTA AL SERVIDOR (One-Shot Fetch)
    suspend fun obtenerConfiguracionGlobal(): AppGlobalConfig {
        return try {
            // .get() obliga a la app a ir a la nube y traer el dato real
            val snapshot = db.collection("Configuraciones").document("Globales").get()

            val config = if (snapshot.exists) {
                snapshot.data<AppGlobalConfig>()
            } else {
                AppGlobalConfig()
            }
            configCargada = config
            config
        } catch (e: Exception) {
            println("YENDO_ERROR: Falló al leer Config Global directa - ${e.message}")
            AppGlobalConfig()
        }
    }
}
